// The Medical Research Council scale (template 18) answers, shared by the MRC
// form and Preview & Save. A muscle is one text answer holding both grades,
// left first: "4,5". "4," and ",5" keep the other side blank, so a draft can
// be saved with one side missing.

// The six muscle groups, each graded 0 to 5 on both sides, in the order of
// the MRC form. The template sends 686 (shoulder) after the total, so the
// form follows this list, not the element order.
export const MRC_MUSCLES = [
  'question686', // Shoulder abductors
  'question680', // Elbow flexors
  'question681', // Wrist extensors
  'question682', // Hip flexors
  'question683', // Knee extensors
  'question684', // Foot dorsiflexors
];

// As the backend reads a grade: a whole number from 0 to 5.
const MRC_WHOLE_NUMBER = /^\d+$/;
const MRC_MAX_GRADE = 5;

// The left and right grades of an answer; a side not given is blank.
export function splitMrcGrades(value: unknown): string[] {
  const [left = '', right = ''] = String(value ?? '').split(',');
  return [left.trim(), right.trim()];
}

// The answer for these grades, or none while both sides are blank.
export function joinMrcGrades(left: string, right: string): string {
  return left || right ? `${left},${right}` : '';
}

// Both sides are graded, which the backend's TryParseMrcGrades needs before
// it scores a muscle: exactly two grades, each a whole number from 0 to 5.
export function hasBothMrcGrades(value: unknown): boolean {
  const grades = String(value ?? '')
    .split(',')
    .map((grade) => grade.trim());

  return (
    grades.length === 2 &&
    grades.every(
      (grade) =>
        MRC_WHOLE_NUMBER.test(grade) && Number(grade) <= MRC_MAX_GRADE,
    )
  );
}
